// src/layout/AppHeader.jsx
import { AppBar, Toolbar, Typography, Avatar, Box, Button } from "@mui/material";

export default function AppHeader({ user, onLogout }) {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ bgcolor: "#ffffff", borderBottom: "1px solid #e5e7eb" }}
    >
      <Toolbar>
        <Avatar sx={{ bgcolor: "#2f80ed", mr: 1, }}></Avatar>


        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={700} color="text.primary">
           {user?.name || ""}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {user?.email || user?.phone || ""}
          </Typography>
        </Box>

        <Button size="small" onClick={onLogout}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
}
